// src/pages/RecoverPwd.jsx
import React, { useState } from "react";
import { Button, Form, Input, Card, Typography, message } from "antd";
import { useLocation } from "wouter";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useAuth } from "../context/AuthContext";

const { Title, Text } = Typography;

const RecoverPwd = () => {
  const [form] = Form.useForm();
  const [, navigate] = useLocation();
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();

  if (currentUser) {
    navigate("/");
    return null;
  }

  const onFinish = async (values) => {
    const { email } = values;
    setLoading(true);
    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      message.success("Un lien de réinitialisation a été envoyé à votre adresse e-mail. Vérifiez votre boîte de réception.");
      setTimeout(() => {
        navigate("/signin");
      }, 3000);
    } catch (error) {
      console.error("Erreur d'envoi du lien de réinitialisation:", error);
      message.error("Impossible d'envoyer le lien de réinitialisation. Veuillez vérifier l'e-mail.");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = () => {
    console.log("Failed");
  };

  return (
    <div className="auth-page-container">
      <Card
        className="auth-card"
        classNames={{ header: "auth-card-header", body: "auth-card-body" }}
      >
        <div className="auth-title-wrapper">
          <Title level={2} style={{ color: "var(--brand-primary)", marginBottom: 8 }}>
            <span className="brand-bio">Bio</span>
            <span className="brand-connect">Connect</span>
          </Title>
          <Text className="auth-subtitle">Réinitialisation du mot de passe</Text>
        </div>

        <Form
          form={form}
          layout="vertical"
          name="recover"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label={<span className="form-label-light">Email</span>}
            name="email"
            rules={[
              { required: true, message: "Veuillez saisir votre email !" },
              { type: "email", message: "Email invalide !" }
            ]}
          >
            <Input
              size="large"
              placeholder="votre@email.com"
              className="input-dark"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              block
              className="btn-submit-primary"
            >
              Recevoir le lien de réinitialisation
            </Button>
          </Form.Item>
        </Form>

        <div className="auth-link-area">
          <Text className="text-dark">Vous vous souvenez de votre mot de passe ? </Text>
          <Button
            type="link"
            onClick={() => navigate("/signin")}
            className="btn-link-brand"
          >
            Se connecter
          </Button>
        </div>

        <div className="auth-link-area-secondary">
          <Text className="text-dark">Pas encore de compte ? </Text>
          <Button
            type="link"
            onClick={() => navigate("/signup")}
            className="btn-link-brand"
          >
            S'inscrire
          </Button>
        </div>

        <div className="auth-footer-divider">
          <Text className="text-small-secondary">
            BioConnect - Système de gestion d'irrigation intelligent
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default RecoverPwd;
